import APIService from './APIService';

export default {
  getConjuntos(mesBdgd, versaoBdgd) {
    return APIService.apiCall().get(`/conjuntos-eletricos/get/${mesBdgd}/${versaoBdgd}`);
  }
};
